var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showConsentBox
    ? _c(
        "div",
        { staticClass: "consent-box", attrs: { id: "ConsentDialog" } },
        [
          _c(
            "div",
            { staticClass: "consent-box__inner" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.consentItems, function(item) {
                  return _c(
                    "div",
                    {
                      staticClass: "consent-item",
                      staticStyle: { padding: "3px 5px 3px 5px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "consent-item__checkbox-container" },
                        [
                          _c("v-switch", {
                            staticClass: "consent-item__checkbox",
                            attrs: { label: item.title },
                            model: {
                              value: item.consentGranted,
                              callback: function($$v) {
                                _vm.$set(item, "consentGranted", $$v)
                              },
                              expression: "item.consentGranted"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "consent-item__link-container" },
                        [
                          item.htmlIsUrl == true
                            ? _c(
                                "a",
                                {
                                  staticClass: "no-select consent-item__link",
                                  attrs: { href: item.html, target: "_blank" }
                                },
                                [_vm._v("more info")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "no-select consent-item__link",
                                  attrs: {
                                    href: "/consent/details/" + item.id,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("more info")]
                              )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "consent-button",
                  attrs: { elevation: "2", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.allConsentsChecked()
                    }
                  }
                },
                [_vm._v("\n      OK\n    ")]
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("We need your consent.")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }